import React, { memo, useCallback, useEffect, useState } from 'react';
import Dialog from '../../Dialog/Modal';
import styles from './Report.module.less';
import RadioGroup from '../../Radio/RadioGroup';
import Btn from '../../Btn/Btn';
import config from '../config';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(
  ({ handleCancel = () => {}, releaseInfo, commentInfo, requestInfo, replyInfo }) => {
    const [options, setOptions] = useState([]);
    const [active, setActive] = useState(null);
    const logInfoData = useSelector(selectLogInfo);
    const dispatch = useDispatch();

    const handelClick = useCallback(async () => {
      if (!active) {
        return;
      }
      try {
        const { status } = await config.reportComment({
          ...requestInfo,
          optType: replyInfo ? '2' : '1',
          commentId: commentInfo?.id,
          replyId: replyInfo?.id,
          targetUserId: replyInfo ? replyInfo?.userId : commentInfo?.userId,
          reasonCond: {
            type: active?.name,
            desc: active?.text,
          },
        });
        dispatch(
          logging({
            category: 'R',
            action: 'Comment_Report_Result',
            label: '',
            param2: {
              source: logInfoData.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              content: active?.text,
              status: status === 0 ? 1 : 0,
              commentId: replyInfo?.id || commentInfo?.id,
            },
          }),
        );
      } catch (err) {}
      handleCancel();
    }, [active, releaseInfo, commentInfo, requestInfo, replyInfo]);
    const handleChange = useCallback(selected => {
      setActive(selected);
    }, []);

    useEffect(() => {
      setOptions(
        releaseInfo?.complaintCauses?.map(item => ({
          ...item,
          name: item.complaintCode,
          text: item.complaintDesc,
        })),
      );
    }, [releaseInfo]);
    return (
      <Dialog
        title="请选择举报原因"
        maskStyle={styles.mask}
        containerStyle={styles.containerStyle}
        handleClose={handleCancel}
      >
        <div>
          <RadioGroup
            group={options}
            radioBoxStyle={styles.radio_box}
            radioGroupStyle={styles.radio_group}
            handleChange={handleChange}
          />
          <div className={styles.btn_container}>
            <Btn className={styles.btn} primary handleClick={handelClick} disabled={!active}>
              提交
            </Btn>
          </div>
        </div>
      </Dialog>
    );
  },
);
